module.exports = __webpack_public_path__ + "img/kids.0fc24e0b.png";